import { faUser } from "@fortawesome/free-solid-svg-icons";
import { isPositiveNumber } from "et3-type-guards";
import React from "react";
import i18n from "../../../../constants/i18n";
import Et3Button from "../../../../core/et3-button";
import { withLiteObserverAndTheme } from "../../../../core/et3-enhanced-render";
import Et3TextInput from "../../../../core/et3-input/et3-text-input";
import Et3Margin from "../../../../core/et3-ui/ET3Margin";
import getSelfieVerificationPhotosStore from "../../../../stores/user-store/selfie-verification-photos-store";

const UserSelfieVerificationPhotosForm = withLiteObserverAndTheme(() => {
  return (
    <React.Fragment>
      <Et3TextInput
        size="MEDIUM"
        withShadow={true}
        type={"number"}
        icon={faUser}
        label={i18n.get("USER_ID")}
        placeHolder={i18n.get("USER_ID")}
        value={getSelfieVerificationPhotosStore().userIDInput.get()}
        onChoose={(value: number) =>
          getSelfieVerificationPhotosStore().userIDInput.set(value)
        }
        onBlur={() => {}}
        onEnter={() => {
          getSelfieVerificationPhotosStore().getUserSelfieVerificationPhotos();
        }}
        style={{}}
      />
      <Et3Margin top={30} bottom={0} left={0} right={0} />
      <Et3Button
        isEnabled={isPositiveNumber(
          getSelfieVerificationPhotosStore().userIDInput.get()
        )}
        onClick={async () => {
          getSelfieVerificationPhotosStore().getUserSelfieVerificationPhotos();
        }}
        size="LARGE"
        text="GET"
        type="GET"
      />
    </React.Fragment>
  );
});
export default UserSelfieVerificationPhotosForm;
